export const cssInput = {
    display: 'block',
    width: '100%',
    height: 'calc(1.5em + 0.75rem + 2px)',
    padding: '0.375rem 0.75rem',
    fontSize: '1rem',
    fontWeight: '400',
    lineHeight: '1.5',
    color: '#495057',
    backgroundColor: '#fff',
    backgroundClip: 'padding-box',
    border: '1px solid #ced4da',
    borderRadius: '0.25rem',
    transition: 'border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out',
}

export const cssTextarea = {
    display: 'block',
    width: '100%',
    padding: '0.375rem 0.75rem',
    fontSize: '1rem',
    fontWeight: '400',
    lineHeight: '1.5',
    color: '#495057',
    backgroundColor: '#fff',
    backgroundClip: 'padding-box',
    border: '1px solid #ced4da',
    borderRadius: '0.25rem',
    transition: 'border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out',
}

export const cssLabel = {
    fontSize: '22px',
    fontWeight: '300',
    marginBottom: '5px',
    display: 'block',
}


// WEBPACK FOOTER //
// ./src/new-components/admin/fields/styled.js